import {postsEndpoint, initSearchForm, cardsEndpoint} from "../util/search";

'../util/search.js';

export default {
	init() {
		// JavaScript to be fired on all pages

		const wordpressPagination = document.querySelector(".page-numbers");

		const rebuildPagination = (element) => {

			element.classList.remove("page-numbers");
			element.classList.add("pagination");

			let listElements = Array.prototype.slice.call(element.children);

			listElements.forEach((item) => {
				item.classList.add("pagination__item");
			});

		};

		rebuildPagination(wordpressPagination);

		if (document.querySelector("body").classList.contains("post-type-archive")) {
			console.log('wyszukiwarka / CPT');

			initSearchForm(cardsEndpoint);
		} else {
			console.log('wyszukiwarka / POSTS');

			initSearchForm(postsEndpoint);
		}

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
